import gql from "graphql-tag";

export const DELETE_GALLERY_PHOTO_BY_KEY = gql`
  mutation deleteGalleryPhotoByKey($realEstateId: String!, $fileName: String!) {
    deleteGalleryPhotoByKey(realEstateId: $realEstateId, fileName: $fileName)
  }
`;
